import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Fade from '../../components/Fade';
import BackButton from '../../components/BackButton';
import arrowIcon from '../../assets/icons/icon-arrow-right.svg';
import {
  MOBILE_BREAKPOINT_IN_PX,
  TABLET_BREAKPOINT_IN_PX,
  LAPTOP_BREAKPOINT_IN_PX,
} from '../../constants';
import CrumbTrailStart from '../../components/CrumbTrailStart';

const BackButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 4px;
  width: 100%;
  padding: 16px 0 0 50px;
  box-sizing: border-box;

  @media screen and (max-width: ${LAPTOP_BREAKPOINT_IN_PX}px) {
    padding-right: 0;
    padding-left: 20px;
    row-gap: 2px;
  }

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    top: 20px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    top: 4px;
    row-gap: 6px;
    padding-left: 20px;
    padding-right: 20px;
    border-bottom: none;
    z-index: 3;
  }
`;

const ArrowIcon = styled.div`
  width: 27px;
  height: 24px;
  background-image: url(${arrowIcon});
  background-size: 12px 14px;
  background-repeat: no-repeat;
  background-position: center left;
  margin-left: 13px;

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    width: 20px;
  }
`;

const BackButtonContainer = ({
  fadeIn,
  textPrev,
  home,
  homeLink,
  secondaryHome,
  secondaryHomeLink,
  text,
  onClick,
}) => {
  const duration = fadeIn ? '0.75s' : '0s';
  return (
    <Fade duration={duration}>
      <BackButtonWrapper>
        <CrumbTrailStart text={home} link={homeLink} />
        <ArrowIcon />
        <CrumbTrailStart text={secondaryHome} link={secondaryHomeLink} />
        <ArrowIcon />
        {textPrev && <BackButton text={textPrev} onClick={onClick} />}
        <BackButton text={text} />
      </BackButtonWrapper>
    </Fade>
  );
};

BackButtonContainer.propTypes = {
  fadeIn: PropTypes.bool,
  textPrev: PropTypes.string,
  home: PropTypes.string.isRequired,
  homeLink: PropTypes.string.isRequired,
  secondaryHome: PropTypes.string.isRequired,
  secondaryHomeLink: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

BackButtonContainer.defaultProps = {
  textPrev: '',
  onClick: null,
  fadeIn: false,
};

export default BackButtonContainer;
